module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "target-definition"
  }, [_c('div', {
    staticClass: "target-definition__statement-container",
    class: {
      'target-definition__drag-and-drop-mode': _vm.isDragAndDropActive
    }
  }, [_c('scroll-panel', {
    attrs: {
      "is-pinned": true
    }
  }, [(_vm.isDragAndDropActive) ? _c('div', {
    staticClass: "target-definition__drag-and-drop-message"
  }, [_c('p', [_vm._v("Drag and Drop is Active")])]) : _vm._e(), _vm._v(" "), _c('target-definition-statement', {
    staticClass: "target-definition__statement",
    attrs: {
      "disabled": _vm.viewOnly,
      "definition": _vm.definition,
      "selected": _vm.selected,
      "enableNot": _vm.enableNot,
      "enableMinus": _vm.enableMinus,
      "enable-drag-and-drop": _vm.isDragAndDropActive,
      "is-dragging-part": _vm.isDraggingPart
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "target-definition__controls"
  }, [(_vm.isTargetEditable) ? _c('definition-controls') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05eadf6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/targetDefinition/components/TargetDefinition.vue
// module id = 1795
// module chunks = 0